import React from 'react'

import { ModuleType } from 'src/models/dto/ModuleDTO'

export interface ModuleBuilderContextProps {
    moduleVersionId: string
    moduleUsingMediaManager: boolean
    lockScoringEditing: boolean
    moduleType?: ModuleType
}

export const ModuleBuilderContext = React.createContext<ModuleBuilderContextProps>({
    moduleVersionId: '',
    moduleUsingMediaManager: false,
    lockScoringEditing: false,
    moduleType: undefined,
})
